const convertMarketsToCSS = (markets) => ({
    '--markets-base-default': markets.base.default,
    '--markets-base-action': markets.base.action,
    '--markets-base-active': markets.base.active,
    '--markets-base-active-action': markets.base.activeAction,
    '--markets-text-default': markets.text.default,
    '--markets-text-action': markets.text.action,
    '--markets-text-active': markets.text.active,
    '--markets-text-active-action': markets.text.activeAction,
});
const convertMarketsToObject = (markets) => ({
    marketsBaseDefault: markets.base.default,
    marketsBaseAction: markets.base.action,
    marketsBaseActive: markets.base.active,
    marketsBaseActionActive: markets.base.activeAction,
    marketsTextDefault: markets.text.default,
    marketsTextAction: markets.text.action,
    marketsActive: markets.text.active,
    marketsTextActiveAction: markets.text.activeAction,
});
const Markets = {
    base: {
        default: 'var(--markets-base-default)',
        action: 'var(--markets-base-action)',
        active: 'var(--markets-base-active)',
        activeAction: 'var(--markets-base-active-action)',
    },
    text: {
        default: 'var(--markets-text-default)',
        action: 'var(--markets-text-action)',
        active: 'var(--markets-text-active)',
        activeAction: 'var(--markets-text-active-action)',
    },
};

export { Markets, convertMarketsToCSS, convertMarketsToObject };
